import { useLocation, Link } from "react-router-dom";
import { useEffect } from "react";

const NotFound = () => {
  const location = useLocation();

  useEffect(() => {
    console.error(
      "404 Error: User attempted to access non-existent route:",
      location.pathname
    );
  }, [location.pathname]);

  return (
    <div className="min-h-screen flex items-center justify-center bg-gradient-to-br from-primary/5 via-background to-accent/5 p-4">
      <div className="text-center max-w-md mx-auto">
        <div className="mb-6">
          <h1 className="text-6xl sm:text-8xl font-bold text-primary mb-4">404</h1>
          <p className="text-lg sm:text-xl text-muted-foreground mb-6">Seite nicht gefunden</p>
          <p className="text-sm text-muted-foreground mb-8">
            Die angeforderte Seite konnte nicht gefunden werden.
          </p>
        </div>
        <Link 
          to="/" 
          className="inline-flex items-center justify-center rounded-md text-sm font-medium ring-offset-background transition-colors focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring focus-visible:ring-offset-2 disabled:pointer-events-none disabled:opacity-50 bg-primary text-primary-foreground hover:bg-primary/90 h-10 px-4 py-2"
        >
          Zurück zur Startseite
        </Link>
      </div>
    </div>
  );
};

export default NotFound;
